module.exports = __webpack_public_path__ + "img/fig23.7ceda6b3.jpg";